/***********************************************************
 * Includes three components that get exported from the main
 * component. The components represent the "Item Details"
 * for each specific product type: Labels, Cartons, and
 * Graphic Design. This is necessary because not all
 * product types need the properties displayed in
 * the same order. 🐺
 * *******************
 *
 * @format
 */

import React from 'react';

const ItemDetailsLabels = ({
    has_variable_data,
    form_factor_label,
    substrate_label,
    laminate_label,
    pantone_qty,
    valueLabel,
    design_qty,
    proofType,
    total_qty,
    backing_label,
    shape
}) => {
    return (
        <>
            {shape && (
                <div className="col-sm-4">
                    <div className="cart-field">
                        <label className="cart-field-label">Shape</label>
                        <p className="cart-field-prop">{shape}</p>
                    </div>
                </div>
            )}

            {substrate_label && (
                <div className="col-sm-4">
                    <div className="cart-field">
                        <label className="cart-field-label">Material</label>
                        <p className="cart-field-prop">{substrate_label}</p>
                    </div>
                </div>
            )}

            {laminate_label && (
                <div className="col-sm-4">
                    <div className="cart-field">
                        <label className="cart-field-label">Finish</label>
                        <p className="cart-field-prop">{laminate_label}</p>
                    </div>
                </div>
            )}

            {total_qty > 0 && (
                <div className="col-sm-4">
                    <div className="cart-field">
                        <label className="cart-field-label">Quantity</label>
                        <p className="cart-field-prop">{total_qty}</p>
                    </div>
                </div>
            )}

            {design_qty > 0 && (
                <div className="col-sm-4">
                    <div className="cart-field">
                        <label className="cart-field-label">Designs</label>
                        <p className="cart-field-prop">{design_qty}</p>
                    </div>
                </div>
            )}

            {form_factor_label && (
                <div className="col-sm-4">
                    <div className="cart-field">
                        <label className="cart-field-label">Application</label>
                        <p className="cart-field-prop">{form_factor_label}</p>
                    </div>
                </div>
            )}

            {backing_label && (
                <div className="col-sm-4">
                    <div className="cart-field">
                        <label className="cart-field-label">Backing</label>
                        <p className="cart-field-prop">{backing_label}</p>
                    </div>
                </div>
            )}

            <div className="col-sm-4">
                <div className="cart-field">
                    <label className="cart-field-label">Proof</label>
                    <p className="cart-field-prop">{proofType}</p>
                </div>
            </div>

            <div className="col-sm-4">
                <div className="cart-field">
                    <label className="cart-field-label">Processing Time</label>
                    <p className="cart-field-prop">{valueLabel}</p>
                </div>
            </div>

            {has_variable_data && (
                <div className="col-sm-4">
                    <label className="cart-field-label">Variable Data</label>
                    <p className="cart-field-prop">Yes</p>
                </div>
            )}

            {pantone_qty > 0 && (
                <div className="col-sm-4">
                    <label className="cart-field-label">Pantones</label>
                    <p className="cart-field-prop">Matching {pantone_qty} Pantone(s)&reg;</p>
                </div>
            )}
        </>
    );
};

const ItemDetailsCartons = ({
    substrate_label,
    laminate_label,
    valueLabel,
    design_qty,
    proofType,
    total_qty
}) => {
    return (
        <>
            {substrate_label && (
                <div className="col-sm-4">
                    <div className="cart-field">
                        <label className="cart-field-label">Material</label>
                        <p className="cart-field-prop">{substrate_label}</p>
                    </div>
                </div>
            )}

            {laminate_label && (
                <div className="col-sm-4">
                    <div className="cart-field">
                        <label className="cart-field-label">Finish</label>
                        <p className="cart-field-prop">{laminate_label}</p>
                    </div>
                </div>
            )}

            {/* for layout purposes only*/}
            <div className="col-sm-4">
                <div className="cart-field">
                    <label className="cart-field-label"></label>
                    <p className="cart-field-prop"></p>
                </div>
            </div>

            {total_qty > 0 && (
                <div className="col-sm-4">
                    <div className="cart-field">
                        <label className="cart-field-label">Quantity</label>
                        <p className="cart-field-prop">{total_qty}</p>
                    </div>
                </div>
            )}

            {design_qty > 0 && (
                <div className="col-sm-4">
                    <div className="cart-field">
                        <label className="cart-field-label">Designs</label>
                        <p className="cart-field-prop">{design_qty}</p>
                    </div>
                </div>
            )}

            {/* for layout purposes only*/}
            <div className="col-sm-4">
                <div className="cart-field">
                    <label className="cart-field-label"></label>
                    <p className="cart-field-prop"></p>
                </div>
            </div>

            <div className="col-sm-4">
                <div className="cart-field">
                    <label className="cart-field-label">Proof</label>
                    <p className="cart-field-prop">{proofType}</p>
                </div>
            </div>

            <div className="col-sm-4">
                <div className="cart-field">
                    <label className="cart-field-label">Processing Time</label>
                    <p className="cart-field-prop">{valueLabel}</p>
                </div>
            </div>
            {/* for layout purposes only*/}
            <div className="col-sm-4">
                <div className="cart-field">
                    <label className="cart-field-label"></label>
                    <p className="cart-field-prop"></p>
                </div>
            </div>
        </>
    );
};

const ItemDetailsGraphics = ({
    form_factor_label,
    substrate_label,
    laminate_label,
    valueLabel,
    proofType,
    color,
    style,
    shape
}) => {
    return (
        <>
            {shape && (
                <div className="col-sm-4">
                    <div className="cart-field">
                        <label className="cart-field-label">Shape</label>
                        <p className="cart-field-prop">{shape}</p>
                    </div>
                </div>
            )}

            {substrate_label && (
                <div className="col-sm-4">
                    <div className="cart-field">
                        <label className="cart-field-label">Material</label>
                        <p className="cart-field-prop">{substrate_label}</p>
                    </div>
                </div>
            )}

            {laminate_label && (
                <div className="col-sm-4">
                    <div className="cart-field">
                        <label className="cart-field-label">Finish</label>
                        <p className="cart-field-prop">{laminate_label}</p>
                    </div>
                </div>
            )}

            {color && (
                <div className="col-sm-4">
                    <div className="cart-field">
                        <label className="cart-field-label">Color</label>
                        <p className="cart-field-prop">{color}</p>
                    </div>
                </div>
            )}

            {style && (
                <div className="col-sm-4">
                    <div className="cart-field">
                        <label className="cart-field-label">Style</label>
                        <p className="cart-field-prop">{style}</p>
                    </div>
                </div>
            )}

            {form_factor_label && (
                <div className="col-sm-4">
                    <div className="cart-field">
                        <label className="cart-field-label">Application</label>
                        <p className="cart-field-prop">{form_factor_label}</p>
                    </div>
                </div>
            )}

            <div className="col-sm-4">
                <div className="cart-field">
                    <label className="cart-field-label">Proof</label>
                    <p className="cart-field-prop">{proofType}</p>
                </div>
            </div>

            <div className="col-sm-4">
                <div className="cart-field">
                    <label className="cart-field-label">Processing Time</label>
                    <p className="cart-field-prop">{valueLabel}</p>
                </div>
            </div>
        </>
    );
};

export const ItemDetails = ({
    has_variable_data,
    form_factor_label,
    substrate_label,
    laminate_label,
    backing_label,
    pantone_qty,
    valueLabel,
    design_qty,
    proofType,
    total_qty,
    color,
    style,
    shape,
    labels,
    cartons,
    graphics,
    ...props
}) => {
    return (
        <>
            {labels && (
                <ItemDetailsLabels
                    form_factor_label={form_factor_label}
                    substrate_label={substrate_label}
                    laminate_label={laminate_label}
                    backing_label={backing_label}
                    pantone_qty={pantone_qty}
                    design_qty={design_qty}
                    valueLabel={valueLabel}
                    proofType={proofType}
                    total_qty={total_qty}
                    shape={shape}
                    {...props}
                />
            )}
            {cartons && (
                <ItemDetailsCartons
                    has_variable_data={has_variable_data}
                    form_factor_label={form_factor_label}
                    substrate_label={substrate_label}
                    laminate_label={laminate_label}
                    design_qty={design_qty}
                    valueLabel={valueLabel}
                    proofType={proofType}
                    total_qty={total_qty}
                    shape={shape}
                    {...props}
                />
            )}
            {graphics && (
                <ItemDetailsGraphics
                    form_factor_label={form_factor_label}
                    substrate_label={substrate_label}
                    laminate_label={laminate_label}
                    pantone_qty={pantone_qty}
                    valueLabel={valueLabel}
                    proofType={proofType}
                    shape={shape}
                    color={color}
                    style={style}
                    {...props}
                />
            )}
        </>
    );
};
